// Страницы документации «Выгрузка клиентов и торговые предложения»: main CustomerController (выгрузка покупателей),
// main ProductController → catalog Dashboard ProductController и OfferService (предложения).
// Методы кабинета: нужен токен входа руководителя.
import type { ApiDocBlock, ApiDocPage } from '../types'

const offer = (price: number, oldPrice: number, discount: number, visibleInApp: string) => `{
  "success": 1,
  "data": {
    "id": 131,
    "parent_id": 57,
    "sort": 20,
    "article": "TS-01-B",
    "barcode": "4600000000031",
    "title": "Футболка, синяя",
    "description": "Синяя футболка из хлопка",
    "price": ${price},
    "old_price": ${oldPrice},
    "discount": ${discount},
    "bonus": 0,
    "active": true,
    "visible_in_app": ${visibleInApp},
    "popular": false,
    "by_order": false,
    "max_amount": 999,
    "properties": [],
    "components": [],
    "created_at": "2026-10-07T09:00:00.000000Z",
    "updated_at": "2026-10-07T09:00:00.000000Z",
    "created_at_timestamp": 1791363600,
    "updated_at_timestamp": 1791363600
  },
  "error": null
}`

const offerErrors: ApiDocBlock = {
  id: 'errors',
  heading: 'Ошибки',
  text: [
    '422 — ошибка проверки: в error.message — первая ошибка, в error.errors — все ошибки по полям.',
    '404 — нет товара с таким id или у него нет предложения с таким id.',
    '401 — нет токена руководителя или он устарел.',
  ],
  code: `{
  "success": 0,
  "data": null,
  "error": {
    "message": "<текст первой ошибки>",
    "errors": {
      "old_price": ["<текст ошибки>"]
    }
  }
}`,
}

export const ioApiDocs: Record<string, ApiDocPage> = {
  ioClients: {
    link: [
      'GET /api/dashboard/v1/chief/customers/download',
      'GET /api/dashboard/v1/chief/customers/send-all-with-webhook',
    ],
    blocks: [
      {
        id: 'about',
        heading: 'Описание',
        text: [
          'Методы этого раздела — методы кабинета: их вызывает руководитель компании с токеном входа в кабинет (Authorization: Bearer).',
          'Выгружаются покупатели, у которых подтверждён email или телефон. Выгрузить можно двумя способами: файлом или отправкой на вебхук.',
        ],
      },
      {
        id: 'download',
        heading: 'Файлом',
        text: [
          'GET /api/dashboard/v1/chief/customers/download отдаёт файл customers.json. Ответ без обёртки success/data/error — сразу содержимое файла.',
          'customer_birthday — дата рождения (ГГГГ-ММ-ДД) или null; customer_created_at — дата регистрации.',
        ],
        code: `{
    "customers": [
        {
            "customer_id": 15,
            "customer_name": "Иван",
            "customer_birthday": "1990-05-01",
            "email": "ivan@example.com",
            "phone": "79001234567",
            "customer_created_at": "2025-02-20T11:55:37+00:00"
        }
    ]
}`,
      },
      {
        id: 'webhook',
        heading: 'Отправкой на вебхук',
        nav: 'На вебхук',
        text: [
          'GET /api/dashboard/v1/chief/customers/send-all-with-webhook ставит отправку списка в очередь на вебхуки события customer.download (раздел «Настройка веб-хуков») и отвечает сразу.',
          'Если вебхука на событие customer.download нет, ответ 400 «Webhook не настроен». Запрос уходит только на включённые вебхуки: если вебхук есть, но выключен, ответ будет ok, а отправки не будет.',
        ],
        code: `{
  "success": 1,
  "data": {
    "message": "ok"
  },
  "error": null
}`,
      },
      {
        id: 'errors',
        heading: 'Ошибки',
        code: `{
  "success": 0,
  "data": null,
  "error": "Webhook не настроен"
}`,
      },
    ],
  },

  ioOffers: {
    link: [
      'POST /api/dashboard/v1/chief/market/products/:id/offers',
      'GET /api/dashboard/v1/chief/market/products/:id/offers/:offer',
      'PUT /api/dashboard/v1/chief/market/products/:id/offers/:offer',
      'DELETE /api/dashboard/v1/chief/market/products/:id/offers/:offer',
    ],
    blocks: [
      {
        id: 'about',
        heading: 'Описание',
        text: [
          'Методы кабинета: их вызывает руководитель компании с токеном входа в кабинет (Authorization: Bearer).',
          ':id — id товара в каталоге, :offer — id предложения из ответа на создание.',
          'Тело запроса — JSON. Картинки этими методами не загружаются.',
          'Чтобы загрузить много предложений по своим ext_id, удобнее «Фид каталога» или импорт через API интеграций.',
        ],
      },
      {
        id: 'create',
        heading: 'Создание',
        text: [
          'Обязательны: title (до 255 символов), description, price.',
          'Не обязательны: article и barcode (строки до 255 символов), old_price, discount (процент от 0 до 100), bonus, sort (число не меньше 0), bonus_multiplier, active, popular, by_order (true/false; by_order: true — «нет в наличии»).',
          'price, old_price и bonus — целые числа не меньше 0; old_price не может быть меньше price.',
        ],
        code: `{
  "title": "Футболка, синяя",               // обязательно
  "description": "Синяя футболка из хлопка", // обязательно
  "price": 1000,                            // обязательно; целое
  "discount": 10,                           // не обязательно; процент
  "article": "TS-01-B",
  "barcode": "4600000000031",               // строка, а не число
  "bonus": 0,
  "sort": 20,
  "active": true,
  "popular": false,
  "bonus_multiplier": false,
  "by_order": false
}`,
      },
      {
        id: 'create-prices',
        heading: 'Как считается цена при создании',
        nav: 'Цена при создании',
        text: [
          'При создании price — цена до скидки. Сохраняется: old_price = price, цена = price × (100 − discount) / 100 с округлением.',
          'Если передана old_price, цена считается от неё: цена = old_price × (100 − discount) / 100, а переданная price не применяется.',
          'В примере выше сохранится цена 900, старая цена 1000, скидка 10.',
        ],
      },
      {
        id: 'create-success',
        heading: 'Ответ на создание',
        text: [
          'Код ответа 201. parent_id — id товара.',
          'Поля, которых не было в запросе, в ответе на создание приходят null (как visible_in_app в примере), хотя сохраняются со значениями по умолчанию. Сохранённые значения показывает GET …/offers/:offer.',
        ],
        code: offer(900, 1000, 10, 'null'),
      },
      {
        id: 'update',
        heading: 'Обновление',
        text: [
          'Все поля не обязательны, меняются только присланные. Правила для полей — как при создании.',
          'При обновлении price — цена после скидки. Передана только price — старая цена пересчитывается от неё и текущей скидки. Переданы price и discount — так же, с новой скидкой. Передана только discount — цена пересчитывается от старой цены.',
          'old_price передаётся только вместе с price, иначе ошибка 422. При смене цены старая цена всё равно пересчитывается.',
        ],
        code: `{
  "discount": 20   // цена станет 800: 1000 × (100 − 20) / 100
}`,
      },
      {
        id: 'update-success',
        heading: 'Ответ на обновление и просмотр',
        nav: 'Ответ на обновление',
        text: ['GET …/offers/:offer и PUT отвечают предложением целиком.'],
        code: offer(800, 1000, 20, 'true'),
      },
      {
        id: 'delete',
        heading: 'Удаление',
        text: [
          'DELETE удаляет предложение. Единственное предложение товара удалить нельзя — ответ 400.',
        ],
        code: `{
  "success": 1,
  "data": {
    "message": "ok"
  },
  "error": null
}`,
      },
      {
        id: 'delete-only',
        heading: 'Если предложение единственное',
        nav: 'Единственное предложение',
        code: `{
  "success": 0,
  "data": null,
  "error": "Нельзя удалять единственное торговое предложение"
}`,
      },
      offerErrors,
    ],
  },
}
